import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Spin, Row, Col, Input, Button, Layout, Table, DatePicker, Select, Modal, message } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'

import {getRefundOrder, refund} from '_src/api/api'
import {getStatus} from './commo/common'
import './order.less'

const { Search } = Input

const { RangePicker } = DatePicker
const { Option } = Select
const { confirm } = Modal

class RefundOrder extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: false,
      modelVisible: false,

      pageData: {
        total: 0, 
        current: 1, 
      },

      params: {
        pageNum: 0,
        pageSize: 10,
        refundType:''
      },

      list: [],

      columns: [
        {
          title: <span>订单编号</span>,
          align: 'center',
          dataIndex: 'orderSn',
          key: 'id',
        },
        {
          title: <span>提交时间</span>,
          align: 'center',
          dataIndex: 'createAt',
          render: item => moment(item).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          title: <span>用户账号</span>,
          dataIndex: 'mobile',
          align: 'center',
        },
        {
          title: <span>退款金额(元)</span>,
          dataIndex: 'realPrice',
          align: 'center',
          render: item => (item / 100).toFixed(2)
        },
        {
          title: <span>支付方式</span>,
          align: 'center',
          render: item => '微信支付'
        },
        {
          title: <span>订单来源</span>,
          dataIndex: 'orderSource',
          align: 'center',
          render: item => 'APP'
        },
        {
          title: <span>订单状态</span>,
          dataIndex: 'status',
          align: 'center',
          render: status => getStatus(status)
        },
        {
          title: <span>收货人</span>,
          dataIndex: 'consignee',
          align: 'center',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => {
            return (
              <div>
                <Link to={{ pathname: '/order/detail?id=' + item.id }} target="_blank" style={{marginRight: 10}}><Button icon="eye">查看</Button></Link>
                <Button style={{marginRight: 10}} onClick={() => this.agreeConfirm(item.id,1)} disabled={item.refundReason.handle}>同意</Button>
                <Button style={{marginTop: 10}} onClick={() => this.agreeConfirm(item.id,2)} disabled={item.refundReason.handle}>拒绝</Button>
              </div>
            )
          }
        },
      ]
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.loadList(params)
  }

  loadList = (params) => {
    this.setState({ isLoading: true })
    getRefundOrder(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })  
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }
  // 通用切换事件
  commonChange = (e, key) => {
    const {params} = this.state
    params.pageNum = 0
    if (e) {
      params[key] = e
    } else {
      delete params[key]
    }
    this.setState({params})
    this.loadList(params)
  }

  // 时间切换
  timerChange = (e) => {
    const {params} = this.state
    params.pageNum = 0
    if (e.length) {
      params.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      params.c = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    } else {
      delete params.createStart
      delete params.createEnd
    }
    this.setState({params})
    this.loadList(params)
  }

  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  addURLParam = (url,key,value) => {
    url +=(url.indexOf("?")==-1?"?":"&")
    url +=key+'='+encodeURIComponent(value)
    return url
  }

  //退款
  agreeConfirm = (id,type) => {
    const self = this
    const {params} = this.state
    confirm({
      title: '温馨提示',
      content: (
        <p>您确定要退款给用户吗</p>
      ),
      okText:type===1?'同意':'拒绝',
      onOk () {
        const hide = message.loading('提交中', 0)
        refund(id, type)
          .then((res)=>{
            hide()
            self.loadList(params)
          })
          .catch(()=>{
            hide()
            message.error('请求超时，请稍后再试')
          })
      },
      onCancel () {
      
      },
    })
  }

  render () {
    const {isLoading, columns, list, pageData} = this.state
    return (
      <Layout className='order-list-page'>
        { this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-header'>
          <Row>
            <Col xl={{ span: 6}} md={{ span: 8 }} style={{ width: 220, marginBottom: 20 }} className="flex-h-a">
              <span >订单状态：</span>
              <Select defaultValue='全部订单' style={{ width: 120 }} onChange={(e)=>this.commonChange(e, 'refundType')}>
                <Option value="">全部订单</Option>
                <Option value={2}>待处理</Option>
                <Option value={1}>已处理</Option>
              </Select>
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 320, marginBottom: 20 }} className="flex-h-a">
              <span >提交时间：</span>
              <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 300, marginBottom: 20 }}className="flex-h-a">
              <span >订单编号：</span>
              <Search style={{ width: 200 }} placeholder="订单编号" onSearch={(e)=>this.commonChange(e, 'orderSn')} enterButton />
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >收货人姓名：</span>
              <Search style={{ width: 200 }} placeholder="收货人姓名" onSearch={(e)=>this.commonChange(e, 'consignee')} enterButton />
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >手机号码：</span>
              <Search style={{ width: 200 }} placeholder="手机号码" onSearch={(e)=>this.commonChange(e, 'mobile')} enterButton />
            </Col>
          </Row>
        </div>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
      </Layout>
    )
  }
}

export default connect(res => ({...res}))(RefundOrder)